<template>
  <q-dialog
    ref="dialogRef"
    @hide="onDialogHide">
    <q-card
      class="q-dialog-plugin q-pa-md"
      style="min-width: 500px; max-width: 95vw">
      <q-card-section>
        <div class="row items-center q-gutter-sm q-mb-sm">
          <q-icon
            :name="symRoundedSmartToy"
            size="32px"
            color="primary" />
          <div>
            <div class="text-h6">{{ t('modelSelection.title') }}</div>
            <div class="text-caption text-grey-7">#{{ queueItem.id }} &mdash; {{ queueItem.original_filename || t('queue.unknownFilename') }}</div>
          </div>
        </div>
        <q-separator spaced />
        <ModelSelector
          :queue-item="queueItem"
          @model-confirmed="onModelConfirmed" />
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          color="primary"
          :label="t('actions.close')"
          @click="onDialogOK" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { symRoundedSmartToy } from '@quasar/extras/material-symbols-rounded'
import { useDialogPluginComponent } from 'quasar'
import { useCompositeI18n } from 'src/CrudManager/Core/composables/useCompositeI18n'
import type { AiQueueItem } from '../types'
import ModelSelector from './ModelSelector.vue'

defineProps<{ queueItem: AiQueueItem }>()
defineEmits([...useDialogPluginComponent.emits, 'model-confirmed'])
const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()
const { t } = useCompositeI18n('core.AiDocumentProcessor')

function onModelConfirmed(queueId: string, modelType: string) {
  // Emit to parent and close dialog
  // (Dialog parent can listen for this event)
  // Optionally, you can call onDialogOK() to close
  // and pass the result
  onDialogOK({ queueId, modelType })
}
</script>
